import { render } from "./FrHome.vue?vue&type=template&id=17b82467"
import script from "./FrHome.vue?vue&type=script&lang=js"
export * from "./FrHome.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__